import { BeyondDateFilterBookingActionsDto } from "./BeyondDateFilterBookingActionsDto";
import { BookingDto } from "./BookingDto";

export class BookingActionDto {
  Bookings: BookingDto[];
  IsPercentSelected: boolean;
  RequestMode: number;
  //InstanceId: number;
  UiViewSource: string;
  BeyondDateFilterBookingActions: BeyondDateFilterBookingActionsDto[];
  Filter_StartDate: Date;
  Filter_EndDate: Date;
  Filter_InstanceId: number;
  Filter_ResourceId: number; 
  Filter_JobId: number;
}